function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresenceBusinessTrip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.49,25.81l1.69-1.69L20.9,13.54,25.48,9A1.72,1.72,0,1,0,23.06,6.5h0l-4.59,4.58L7.85,8.85,6.17,10.54l8.52,4.36-4.58,4.56-2.86-.35L6,20.36l3.65,2,2,3.65,1.26-1.26-.36-2.85,4.59-4.59Z",
    style: {
      fill: "#7c7c7c"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresenceBusinessTrip);
export default __webpack_public_path__ + "static/media/presence-business_trip.68313463.svg";
export { ForwardRef as ReactComponent };